export const modalMessageClassName = "js-e2e-modal-content";
